import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCosmetologyCommissionsByUser } from '../../../../appRedux/actions';
import { stringDate, stringTime } from '../../../../util/formatTime';
import { Table } from 'antd';
import { commissionConst, filtersCosm } from '../../../../constants/Commissions.const';
import { TableFilters } from '../../../uiComponents';
import { formatPrice } from '../../../../util/formatPrice';
import { TableFooterTotal } from '../../../uiComponents/TableFooterTotal/TableFooterTotal';

export const CosmetologyCommissionModalBody = ({ id, isCosmetologist }) => {
  const dispatch = useDispatch();
  const { cosmetologyCommissionsByUser } = useSelector(
    (state) => state.cashSales
  );
  const { filtersData } = useSelector((state) => state.generalStates);

  useEffect(() => {
    if (id)
      dispatch(getCosmetologyCommissionsByUser(id, { params: filtersData }));
  }, [dispatch, id, filtersData]);

  const orders = useMemo(() => {
    const orders = cosmetologyCommissionsByUser?.orders;
    return Array.isArray(orders) ? orders : [];
  }, [cosmetologyCommissionsByUser]);
  const totals = useMemo(() => {
    return cosmetologyCommissionsByUser?.totals ?? { sales: 0, commissions: 0 };
  }, [cosmetologyCommissionsByUser]);

  const columns = [
    { title: 'Orden', dataIndex: 'orderNumber', key: 'orderNumber' },
    {
      title: 'Comisionista',
      dataIndex: 'seller',
      key: 'seller',
    },
    {
      title: 'Sucursal',
      dataIndex: 'branch',
      key: 'branch',
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (date) => stringDate(date),
    },
    {
      title: 'Hora',
      dataIndex: 'time',
      key: 'time',
      render: (time) => {
        return stringTime(time);
      },
    },
    {
      title: 'Cliente',
      dataIndex: 'customer',
      key: 'customer',
    },
    {
      title: 'Venta',
      dataIndex: 'total',
      key: 'total',
      render: (total) => formatPrice(total),
    },
  ];

  return (
    <>
      {isCosmetologist && <TableFilters filters={filtersCosm} />}
      <Table
        rowKey={(row) =>
          row?.id ??
          row?.orderNumber ??
          `${row?.orderNumber}-${row?.created_at}`
        }
        dataSource={orders}
        columns={columns}
        pagination={{
          defaultPageSize: 5,
          pageSizeOptions: [5, 10, 15],
        }}
        summary={() => (
          <TableFooterTotal totals={[
            { total: totals?.commissions, label: commissionConst.TOTAL_COMMISSION },
            { total: totals?.sales, label: commissionConst.TOTAL_SALES },
          ]} />
        )}
      />
    </>
  );
};
